import { Routine } from 'redux-saga-routines';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import { getReportRoutine, searchReportUsersRoutine } from './routines';
import { downloadReport } from '../../common/helpers/fileHelper';
import { getReport } from '../../services/candidateService';
import { searchUsers } from '../../services/userService';
import { errorToast, infoToast, successToast } from '../../common/helpers/toastrHelper';

function* getReportReq({ payload }: Routine<any>) {
  try {
    let successId = '';
    let successDefaultText = '';
    if (payload.sendByEmail) {
      yield call(infoToast, 'Preparing report(s) to email', 'toast.reportEmailInfo');
      successId = 'toast.reportEmailSuccess';
      successDefaultText = 'Success! Emailed report(s) are on the way';
    } else {
      yield call(infoToast, 'Preparing report(s) for download', 'toast.reportDownloadInfo');
      successId = 'toast.reportDownloadSuccess';
      successDefaultText = 'Success! Downloading report(s) now';
    }

    const res = yield call(getReport, payload);
    if (res) {
      if (res.name) {
        downloadReport(res.file, res.name);
      } else {
        downloadReport(res);
      }
    }
    yield put(getReportRoutine.success());
    yield call(successToast, successDefaultText, successId);
  } catch (error) {
    yield put(getReportRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchGetReportReq() {
  yield takeEvery(getReportRoutine.TRIGGER, getReportReq);
}

function* searchUsersReq({ payload }: Routine<any>) {
  try {
    const data = payload.trim() ? yield call(searchUsers, payload) : [];
    yield put(searchReportUsersRoutine.success(data));
  } catch (error) {
    yield put(searchReportUsersRoutine.failure(error.message));
  }
}

function* watchSearchUsersReq() {
  yield takeEvery(searchReportUsersRoutine.TRIGGER, searchUsersReq);
}

export default function* reportSaga() {
  yield all([watchGetReportReq(), watchSearchUsersReq()]);
}
